import { useEffect, useState } from 'react';

const validSlug = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function ConfirmedSlugField({
  label,
  slug,
  routeFor,
  onConfirm,
}: {
  label: string;
  slug: string;
  routeFor(slug: string): string;
  onConfirm(slug: string): void;
}) {
  const [pendingSlug, setPendingSlug] = useState(slug);
  const [reviewing, setReviewing] = useState(false);
  const changed = pendingSlug !== slug;
  const valid = validSlug.test(pendingSlug);

  useEffect(() => {
    setPendingSlug(slug);
    setReviewing(false);
  }, [slug]);

  return (
    <div className="confirmed-slug-field">
      <label className="field">
        <span>{label}</span>
        <input
          aria-label={label}
          value={pendingSlug}
          aria-invalid={!valid}
          onChange={(event) => {
            setPendingSlug(event.currentTarget.value.toLowerCase().replaceAll(' ', '-'));
            setReviewing(false);
          }}
        />
      </label>
      {!valid ? (
        <small className="field-error">Use lowercase letters, numbers and single hyphens.</small>
      ) : null}
      {changed && valid && !reviewing ? (
        <button className="button button--quiet" type="button" onClick={() => setReviewing(true)}>
          Review URL change
        </button>
      ) : null}
      {changed && valid && reviewing ? (
        <div className="confirmed-slug-field__review" role="status">
          <p>
            The public URL will change from <code>{routeFor(slug)}</code> to{' '}
            <code>{routeFor(pendingSlug)}</code>. The old URL will permanently redirect to the new
            one.
          </p>
          <div>
            <button
              className="button button--primary"
              type="button"
              onClick={() => {
                onConfirm(pendingSlug);
                setReviewing(false);
              }}
            >
              Confirm URL change
            </button>
            <button
              className="button button--quiet"
              type="button"
              onClick={() => {
                setPendingSlug(slug);
                setReviewing(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
